import React from 'react';
function InterRight({ size, stroke = 'currentColor', ...otherProps }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke={stroke}
      {...otherProps}
    >
      <path
        d="M12.4665 17L11.5918 16.1415L14.6288 13.127H7V11.873H14.6288L11.5918 8.86334L12.4665 8L17 12.5L12.4665 17Z"
        fill="currentColor"
        stroke="transparent"
      />
    </svg>
  );
}

export default InterRight;
